import { addToCartUtlityFn, getPriceCatalogKey, isPriceInitialized } from '../../utils/equipment';
import { AnalyticsEventAttribute } from '../../constants/AnalyticsEventAttribute';
import { LocationSelector } from '../../types/location';
import { RootState, useAppSelector } from '../../redux/store';
import { useEffect, useState } from 'react';
import { useLocationSelector } from '../../hooks/useLocationSelector';
import {
  Label,
  RootContainer,
  Actions,
  BranchAndPriceContainer,
  AddToCartButton,
  QuantityCounter,
  PriceWidget,
  SelectLocation,
  LocationIcon,
  ActionContainer,
  ContactUs,
  ContactUsNumber,
} from './ProductCallToActionStyle';

interface ProductCTAProps {
  equipmentId: string | number;
}

function ProductCallToAction({ equipmentId }: ProductCTAProps) {
  const location = useAppSelector((state: RootState) => state.location.userLocation);
  const branchId = useAppSelector((state: RootState) => state.location.branch?.branch_id);

  const [showContactUsMessage, setShowContactUsMessage] = useState<boolean>(false);
  const locationSelector = useLocationSelector();

  const priceEntry = useAppSelector(
    (state: RootState) => state.prices.priceCatalog[getPriceCatalogKey(equipmentId)],
  );

  const [quantity, setQuantity] = useState(1);

  const handleAddToCart = () => {
    addToCartUtlityFn(equipmentId, quantity);
  };

  const handleSelectLocation = () => {
    locationSelector.open(LocationSelector.MODAL);
  };

  useEffect(() => {
    if (branchId && priceEntry && isPriceInitialized(priceEntry.status)) {
      setShowContactUsMessage(!priceEntry?.price);
    }
  }, [priceEntry]);

  return (
    <RootContainer>
      <BranchAndPriceContainer>
        <PriceWidget equipmentId={equipmentId} day week month />
        {!location?.address && (
          <SelectLocation onClick={handleSelectLocation}>
            <LocationIcon />
            Set location to see prices
          </SelectLocation>
        )}
      </BranchAndPriceContainer>

      {showContactUsMessage && (
        <ContactUs>
          For pricing, please contact us directly at{' '}
          <ContactUsNumber
            data-event-tracking={AnalyticsEventAttribute.MainPhone}
            href='tel:+18888073687'
          >
            1.888.80.RENTS
          </ContactUsNumber>
        </ContactUs>
      )}

      <ActionContainer>
        <Label>Quantity</Label>
        <Actions>
          <QuantityCounter quantity={quantity} setQuantity={setQuantity}></QuantityCounter>
          <AddToCartButton onClick={handleAddToCart}>Add to cart</AddToCartButton>
        </Actions>
      </ActionContainer>
    </RootContainer>
  );
}

export default ProductCallToAction;
